module.exports = __webpack_public_path__ + "img/four.eabf9d79.png";